import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Crosshair, Plus } from 'lucide-react';

import { Skeleton } from 'src/stage/StageUi';
import { TargetBar } from './TargetCard';
import { listTargets } from './targetsApi';
import { PERIODS, STATUS, STATUS_RANK, formatValue, targetTitle } from './targetMeta';
import './targets.css';

// AUTO-CRM-32: Home's view of targets: the company's and your own, the ones
// that need attention first.
export default function HomeTargets({ me }) {
  const [targets, setTargets] = useState(undefined);
  useEffect(() => {
    let active = true;
    const rows = (result) => (Array.isArray(result?.data) ? result.data : []);
    listTargets().then((result) => { if (active) setTargets(rows(result)); }).catch(() => { if (active) setTargets(null); });
    const reload = () => listTargets().then((result) => { if (active) setTargets(rows(result)); }).catch(() => {});
    window.addEventListener('crm:followups-changed', reload);
    return () => { active = false; window.removeEventListener('crm:followups-changed', reload); };
  }, []);
  if (targets === null) return null;
  const relevant = (targets || []).filter((target) => target.scope === 'company' || String(target.user?.id) === String(me))
    .sort((a, b) => (STATUS_RANK[a.progress?.status] ?? 2) - (STATUS_RANK[b.progress?.status] ?? 2));
  const shown = relevant.slice(0, 4);
  const behind = relevant.filter((target) => ['behind', 'at_risk', 'missed'].includes(target.progress?.status)).length;

  return (
    <section className="ws-card crm-home-targets ws-rise" aria-label="Targets">
      <div className="ws-card-head"><h2 className="ws-h3 ws-grow">Targets</h2><Link className="crm-link" to="/targets">{relevant.length > shown.length ? `All ${relevant.length} targets` : 'All targets'}</Link></div>
      <p className="ws-muted">{targets === undefined ? 'Checking your targets…' : !relevant.length ? 'No targets yet. Set a goal so everyone knows what “good” looks like today.' : behind ? `${behind} of ${relevant.length} need attention.` : `All ${relevant.length} on track.`}</p>
      {targets === undefined ? (
        <ul className="crm-home-targets-grid">{[0, 1, 2].map((key) => <li key={key}><Skeleton height={88} radius={14} /></li>)}</ul>
      ) : !shown.length ? (
        <Link className="ws-btn ws-btn--primary ws-btn--sm" style={{ marginTop: 10 }} to="/targets"><Plus size={14} />Set a target</Link>
      ) : (
        <ul className="crm-home-targets-grid">
          {shown.map((target) => {
            const status = STATUS[target.progress?.status] || STATUS.on_track;
            return (
              <li key={target.id}>
                <Link className="crm-mini-target" to="/targets">
                  <span className="crm-mini-target-top"><Crosshair size={13} aria-hidden="true" color="#147DB5" /><b>{targetTitle(target)}</b><span className={`crm-target-status is-${status.tone}`}>{status.label}</span></span>
                  <span className="crm-mini-target-num"><strong>{formatValue(target, target.progress?.actual)}</strong> / {formatValue(target, target.target_value)} {PERIODS[target.period]?.this}{target.user ? ` · ${target.user.name.split(/\s+/)[0]}` : ''}</span>
                  <TargetBar target={target} size="sm" />
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
